import { coreEnv } from '../env';
import { resolveTenantSlug } from './resolve-tenant-slug';

/** Слаг текущего тенанта: env-override (локальная разработка) → поддомен */
export function getCurrentTenantSlug(): string | null {
  if (coreEnv.tenantOverride) {
    return coreEnv.tenantOverride;
  }
  if (typeof window === 'undefined') {
    return null;
  }
  return resolveTenantSlug(window.location.hostname);
}
